import { InternalAccount } from "@wingspanhq/wingspan-api-sdk";

export const selectorActiveBankingAccount = (
  internalAccount: InternalAccount
) => internalAccount.type === "Banking" && internalAccount.status === "Active";
